import {Modal} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {SvgIcon} from "../../ui/SvgIcon";
import Close from "../../images/newDesign/close.nocolor.svg";
import Button from "../../common/Button";
import {InsuranceModalStyled} from "./InsuranceModal.styled";

export function InsuranceModal({ item, onConfirm ,onClose = (result) => void null }) {
    const {t} = useTranslation();
    return (
        <InsuranceModalStyled show={true} onHide={() => onClose('close')} centered size="lg">
            <Modal.Header>
                <button onClick={() => onClose('close')}>
                    <SvgIcon href={Close} size={16}/>
                </button>
            </Modal.Header>
            <Modal.Body>
                <h1 className="bllink-heading1">{t('archive.insurance_title')}</h1>
                <center className="bllink-text">
                    <div className="advantages-block">{t('archive.insurance_advantages')}</div>
                    <div>{t('archive.insurance_conditions')}</div>
                    <div className="buttons-block">
                        <div onClick={() => onClose('close')} className="decline">{t('archive.insurance_disagree')}</div>
                        {/* add request to BE to send an email when api is ready */}
                        <Button onClick={() => onConfirm(onClose)}>{t('archive.insurance_confirm')}</Button>
                    </div>
                </center>
            </Modal.Body>
        </InsuranceModalStyled>
    );
}
